import React, { useState } from "react";
import "../css/assessmentTabs.css";
import "../css/hpcParentAssessment.css";

const AssessmentTabs = ({ mapTabs, tabId, setTabId }) => {

    const [text, setText] = useState("");

    const handleClick = (id) => {
        setTabId(id);
    }
    const handleTouchStart = (id) => {
        if (handleClick.timer) {
            clearTimeout(handleClick.timer);
            delete handleClick.timer;
        }

        handleClick.timer = setTimeout(() => handleClick(id), 300);
    };

    return (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-centered padding-remove">
            <div className="parent-assessment-tabs" >
                {Object.keys(mapTabs).map((id) => (
                    <div
                        key={id}
                        className={id === tabId ? "parent-assessment-tab-active" : "parent-assessment-tab"}
                        onClick={() => handleClick(id)}
                        onTouchStart={() => handleTouchStart(id)}
                    >
                        <a className="nav-link">{mapTabs[id]}</a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AssessmentTabs;